import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <main className="pt-40 pb-32 px-6 md:px-12 lg:px-16 max-w-3xl mx-auto text-center" data-testid="payment-cancel">
      <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B]">Payment cancelled</p>
      <h1 className="font-serif text-5xl mt-4">No worries — your bag is saved.</h1>
      <p className="mt-4 text-[#4A4A4A]">You can head back and complete checkout whenever you’re ready.</p>
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/checkout" className="btn-editorial">Return to checkout</Link>
        <Link to="/" className="btn-editorial-ghost">Back to home</Link>
      </div>
    </main>
  );
}
